import styled from 'styled-components';

export const StyledInputLabel = styled.label`
  font-family: ${props => props.theme.fonts.basic};
  font-size: 14px;
  font-weight: 500;
  color: #6a6b6e;
  text-transform: capitalize;
`;
